import {Injectable} from '@angular/core';
import {ApiVersion} from '../constants/apis';
import {AbstractService} from './abstract.service';
import {UnlockedDocument} from '../models/unlocked-document.model';
import {environment} from '../../environments/environment';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class DocumentService extends AbstractService {

  constructor(private http: HttpClient) {
    super();
  }

  unlockDocument(documentId: string): Observable<void> {
    const url = this.toFinraApiServiceUrl(ApiVersion.V1, 'documents/' + documentId + '/unlock');
    return this.http.post<void>(url, null);
  }

  lockDocument(documentId: string): Observable<void> {
    const url = this.toFinraApiServiceUrl(ApiVersion.V1, 'documents/' + documentId + '/lock');
    return this.http.post<void>(url, null);
  }

  listUnlockedDocument(): Observable<UnlockedDocument[]> {
    const url = this.toFinraApiServiceUrl(ApiVersion.V1, 'documents/unlocked');
    return this.http.get<UnlockedDocument[]>(url);
  }

  getAodocsDocumentUrl(unlockedDocument: UnlockedDocument): string {
    return environment.aodocsUrl + '#Menu_viewDoc/LibraryId_' + unlockedDocument.libraryId + '/DocumentId_' + unlockedDocument.documentId;
  }

}
